import React from 'react';
import { CheckCircle2 } from 'lucide-react';
export function WhatsIncludedSection() {
  const items = ['Plug-and-play electric pump', '75-foot hose', 'Adjustable trigger jet spray wand', 'External siphon intake line', 'Mounts to your own container or toolbox'];
  return <section className="py-16 bg-white" data-id="element-927">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-928">
        <h2 className="text-3xl font-bold text-brand-dark mb-8" data-id="element-929">
          What's Included
        </h2>
        <div className="bg-brand-light p-8 rounded-xl border border-gray-200" data-id="element-930">
          <ul className="space-y-4" data-id="element-931">
            {items.map((item, index) => <li key={index} className="flex items-start" data-id="element-932">
                <CheckCircle2 className="h-6 w-6 text-brand-yellow mr-3 mt-0.5 flex-shrink-0" data-id="element-933" />
                <span className="text-gray-700 text-lg" data-id="element-934">{item}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}